import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExamesMacroscopiaPage from './exames.page';
import WebapiCommon from '@common/util/webapi.common';
import { bindActionCreators } from 'redux';
import * as actions from '../../macroscopia.action';

class ExamesMacroscopiaContainer extends Component {
  render() {
    return <ExamesMacroscopiaPage examesemaberto={this.props.examesemaberto} />;
  }

  componentDidMount() {
    WebapiCommon.getExamesEmAberto(this.props.detalhes.prontuario, this.props.detalhes.laudo).then(
      (exames) => {
        this.props.actions.preencherExamesEmAbertoMacroscopia(exames);
      }
    );
  }
}

const mapStateToProps = (state) => {
  return {
    examesemaberto: state.macroscopia.examesAbertos,
    detalhes: state.commonReducer.detalhes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExamesMacroscopiaContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/exames/exames.container.js